import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { RunHistory } from './run_history';
import { Overview } from './overview';
import JobIcon from '../../assets/jobs_icon.png';
import { getJobOverview, getJobDependenciesChart } from '../../service/service';
import { dashboardUrl } from '../../service/config';
import { ReactComponent as MoreVertIcon } from '../../assets/system-uicons_circle-menu_disabled.svg';
import IconButton from '@mui/material/IconButton';
import '../jobs/jobDetails.css';
import { Link, Stack, Typography } from '@mui/material';
import { PaginationDetailsJobLinage } from '../pagination_details_jobLineage';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import Loader from '../Loader/loader';
import { useTheme } from "@mui/material/styles";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{<Box>{children}</Box>}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`
	};
}

export default function jobDetails() {
	const theme = useTheme();
	const location = useLocation();
	const params = useParams();
	const dataFetchedRef = useRef(false);
	const [job, setJob] = useState(location.state);
	const [succssorPageCountValue, setSuccssorPageCount] = useState(1);
	const [predecessorPageCountValue, setpredecessorPageCount] = useState(1);
	const [pageChangeSuccessor, setPageChangeSuccessor] = useState(1);
	const [pageChangePredecessor, setPageChangepredecessor] = useState(1);
	const [countTot, setCountTot] = useState(10);
	const [pageSuccessor, setPageSuccessor] = useState(1);
	const [pagePredecessor, setPagePredecessor] = useState(1);
	const [succssorTotal, setSuccssorTotal] = useState();
	const [predecessorTotal, setPredecessorTotal] = useState();
	const [error, setError] = useState(false);
	// Tab
	const [tabValue, setTabValue] = useState(0);
	// scroll issue on initial load
	const [view, setView] = useState(false);
	useEffect(() => {
		setTimeout(() => {
			setView(true);
		}, 8000);
	}, []);

	const navigate = useNavigate();
	const handleTabChange = (event: React.SyntheticEvent, newValue: any) => {
		setTabValue(newValue);
		switch (newValue) {
			case 0:
				window.location.href = `/jobs/${params.jobId}/overview`;
				break;
			case 1:
				navigate(`/jobs/${params.jobId}/run_history`);
				break;
			case 2:
				navigate(`/jobs/${params.jobId}/job_dependencies`);
				break;
			default:
				navigate(`/jobs/${params.jobId}`);
				break;
		}
	};
	// Tab

	const afterUpdate = (jobData: any) => {
		fetchJobData();
	};

	async function fetchJobData() {
		if (!params.jobId) return false;
		const res = await getJobOverview(params && params.jobId);
		if (res.success) {
			const jobRes = res.data;
			console.log(jobRes, 'jobRes=')
			setJob(jobRes);
		}
	}
	async function fetchDependency() {
		if (!params.jobId) return false;
		const res = await getJobDependenciesChart(params && params.jobId);
		setSuccssorPageCount(res.data.succssorPageCount);
		setpredecessorPageCount(res.data.predecessorPageCount);
		setSuccssorTotal(res.data.succssorTotalCount);
		setPredecessorTotal(res.data.predecessorTotalCount);
	}
	const handlePageChangeSuccssor = (event: React.ChangeEvent<unknown>, value: number) => {
		setPageChangeSuccessor(value);
		setPageSuccessor(value);
	};
	const handlePageChangePredecessor = (event: React.ChangeEvent<unknown>, value: number) => {
		setPageChangepredecessor(value);
		setPagePredecessor(value);
	};
	const handleCount = (event: any) => {
		const value = event.target.value;
		if (value.trim() === '') {
			setError(true);
			setCountTot(1);
		} else {
			setError(false);
			setCountTot(value);
		}

		if (succssorTotal !== undefined) {
			const successorPageCountvar = Math.ceil(succssorTotal / event.target.value);
			setSuccssorPageCount(successorPageCountvar);
		}
		if (predecessorTotal !== undefined) {
			const predecessorPageCountvar = Math.ceil(predecessorTotal / event.target.value);
			setpredecessorPageCount(predecessorPageCountvar);
		}
	};

	useEffect(() => {
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		localStorage.setItem('overviewPageHit', 'true');
		fetchJobData();
		fetchDependency();
		if (location.pathname.includes('run_history')) setTabValue(1);
		else if (location.pathname.includes('job_dependencies')) setTabValue(2);
		else setTabValue(0);
	}, [params.jobId]);

	return job && job.id ? (
		<div className="page-table job_details_page_table">
			<Box display="flex" alignItems="center" gap={1}>
				<Box
					component="img"
					src={JobIcon}
					alt="Job Icon"
					sx={{ width: 20, height: 20 }}
				/>
				<Link
					href="/jobs"
					sx={{
						textDecoration: "none",
					}}
				>
					<Typography variant="breadcrumbs" sx={{ color: "#003771" }}>
						Jobs
					</Typography>
				</Link>
				<ArrowForwardIosIcon
					sx={{
						fontSize: 14,
						color: "#003771",
						mx: 0.5,
					}}
				/>
				<Typography
					variant="breadcrumbs"
					sx={{ color: "#003771" }}
				>
					{job?.name}
				</Typography>
			</Box>
			<Box sx={{ width: '100%', paddingTop: '10px' }}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						float: 'right',
						borderBottom: 'none',
						marginTop: '-44px', marginRight: '-27	px'
					}}
				>
					<Tabs value={tabValue} onChange={handleTabChange}
						sx={{
							'& .MuiTab-root': {
								...theme.typography.tabLabel,
								textTransform: 'none',
								minHeight: 40,
								borderTopLeftRadius: 4,
								borderTopRightRadius: 4,
								backgroundColor: `${theme.palette.Tab.inActive.bgColor} !important`,
								color: `${theme.palette.Tab.inActive.color} !important`,
							},
							'& .MuiTab-root.Mui-selected': {
								backgroundColor: `${theme.palette.Tab.Active.bgColor} !important`,
								color: `${theme.palette.Tab.Active.color} !important`,
							},
						}}
					>
						<Tab label="Overview" {...a11yProps(0)} />
						<Tab label="Execution History" {...a11yProps(1)} />
						<Tab label="Job Lineage" {...a11yProps(2)} sx={{ width: 'fit-content !important' }} />
					</Tabs>
					<Box>
						{!location.pathname.includes('run_history') && (
							<Box>
								<IconButton
									aria-label="more"
									id="more-button"
									aria-haspopup="true"
									sx={{
										zIndex: 999,
										borderRadius: 0,
										marginTop: '5px',
										marginLeft: '7px'
									}}
									disabled={true}
								>
									<MoreVertIcon
										style={{
											height: 15,
											width: 20,
											zIndex: 999
										}}
									/>
								</IconButton>
							</Box>
						)}
					</Box>
				</Box>

				<br />
				<TabPanel value={tabValue} index={0}>
					<Overview jobId={params.jobId} afterUpdate={afterUpdate} jobOverview={job} tabValue={tabValue} />
				</TabPanel>
				<TabPanel value={tabValue} index={1}>
					<RunHistory jobId={params.jobId} jobData={job} tabValue={tabValue} />
				</TabPanel>
				<TabPanel value={tabValue} index={2}>
					<>{console.log('JobdependencyDashboard')}</>
					{view && (
						<>
							<Stack>
								<AnalyticsVisualization
									params={{
										dashboardUrl: dashboardUrl.jobLineage,
										className: 'jobDependencyIframeContainer',
										otherParams: {
											'var-jobId': params.jobId,
											'var-count': countTot,
											'var-successorPage': pageChangeSuccessor,
											'var-predecessorPage': pageChangePredecessor
										}
									}}
								/>
							</Stack>
							<PaginationDetailsJobLinage
								succssorPageCountValue={succssorPageCountValue}
								predecessorPageCountValue={predecessorPageCountValue}
								handlePageChangeSuccssor={handlePageChangeSuccssor}
								handleCount={handleCount}
								handlePageChangePredecessor={handlePageChangePredecessor}
								pageSuccessor={pageSuccessor}
								pagePredecessor={pagePredecessor}
								succssorTotal={succssorTotal}
								predecessorTotal={predecessorTotal}
								countTot={countTot}
								error={error}
							/>
						</>
					)}
				</TabPanel>
			</Box>
		</div>
	) : (
		<Loader />
	);
}
